import { FunctionalComponent, Fragment, h } from "@stencil/core";

import { NotificationItem } from "../../services/notification/notification.service";

import { TRACKING_CATEGORY } from "./consts";

function getStatusClassName({ iconName }: NotificationItem): string {
  return iconName === "icon-exclamation-mark-circle"
    ? "notification--error"
    : "";
}

export const NotificationBoxLight: FunctionalComponent<{
  notification: NotificationItem;
  trackByEvent(event: Event): void;
}> = ({ notification, trackByEvent }) => {
  return (
    <a
      class={`notification ${getStatusClassName(notification)} ${
        notification.link ? "" : "no-hover"
      }`}
      href={notification.link}
      onClick={trackByEvent}
      data-tracking-category={TRACKING_CATEGORY}
      data-tracking-label={"notification-box"}
    >
      <div class="header-section">
        <div>
          <i
            class={`icon ${notification.iconName} icon--s2`}
            aria-hidden="true"
          />
        </div>
        <div class="ctHidden notification-message">
          <span class="text-b2" title={notification.title}>
            {notification.title}
          </span>
          {notification.content.map(desc => (
            <Fragment>
              <br />
              <span class="text-sm" title={desc}>
                {desc}
              </span>
            </Fragment>
          ))}
        </div>
      </div>
    </a>
  );
};
